export default "__VITE_ASSET__CkGoSUs4__"